import React from 'react'

import Icon from 'lemon-campaign-ui/lib/molecules/Icon'

export default ({ component, defaults }) => {
  return (
    <Icon
      {...defaults}

      size={component.content.size}
      icon={component.content.icon}
      align={component.content.align}
      color={component.content.color}
    />
  )
}
